<template>
    <div v-if="!showOptionSetting">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_stt_extension_setting'"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <td style="width:50%" class="object-item" v-t="'message.info_need_purchase_enterprise_plan'"></td>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="object-titlebox">
            <div class="title-box-left">
                <span v-t="'message.title_stt_extension_p2p_engine'"/>
                <el-tooltip effect="dark" placement="top-start">
                    <div slot="content" style="text-align:left" v-html="$t('message.hint_stt_extension_select_p2p_engine')"></div>
                    <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt=""/>
                </el-tooltip>
            </div>
        </div>
        <table width="100%">
            <tr class="dict-title">
                <td class="object-item1" style="width:40%" v-t="'message.item_stt_extension_p2p_stt_engine'"></td>
                <td class="object-item1" style="width:30%" v-t="'message.item_stt_extension_p2p_translation_engine'"></td>
                <td class="object-item2" ></td>
                <td class="object-item1" style="text-align:right; padding-right:10px; width:30%">
                    <button class="transparent-button" type="button" v-on:click="showSettingP2PEngine()">
                        <img src="../../../../assets/edit.svg"/>
                        <span class="normal-command-text" v-t="'message.common_action_edit'"></span>
                    </button>
                </td>
            </tr>
            <tr class="dict-record">
                <td class="object-item1">
                    {{ sttEngineName }}
                    <div style="color: red">{{ sttEngineCaution}}</div>
                </td>
                <td class="object-item1">
                    {{ translateEngineName }}
                </td>
                <td class="object-item2"></td>
                <td class="object-item2"></td>
            </tr>
        </table>
        <setP2PEngine v-if="showP2PEngineSettingDialog" ref="SetP2PEngine" :sttEngine="selectedSttEngineType" :translationEngine="selectedTranslationEngineType" @cancel="showP2PEngineSettingDialog=false" @setEngine="setP2PEngine"></setP2PEngine>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import SttDictionaryAdd from "@/components/pc/setting/sttextention/SttDictionaryAdd";
import SttDictionaryAssignToTalkGroup from "@/components/pc/setting/sttextention/SttDictionaryAssignToTalkGroup";
import SttDictionaryEdit from "@/components/pc/setting/sttextention/SttDictionaryEdit";
import SttP2PEngineEdit from "@/components/pc/setting/sttextention/SttP2PEngineEdit";
import DeleteObject from "../../../DeleteObject.vue";

export default {
    components: {
        addDictionary: SttDictionaryAdd,
        assignDictionary: SttDictionaryAssignToTalkGroup,
        editDictionary: SttDictionaryEdit,
        setP2PEngine: SttP2PEngineEdit,
        deleteDictionary: DeleteObject,
    },

    data() {
        return {
            showDictionaryDialog: {
                add: false,
                assign: false,
                edit: false,
                delete: false,
            },
            showP2PEngineSettingDialog: false,
            maxDictionaryCount: 0,
            dictionaryInfoList: [],
            selectedDictionaryInfo: null,
            confirmInfo: {
                objectName: null,
                objectTitle: null,
            },
            selectedSttEngineType: null,
            selectedTranslationEngineType: null
        }
    },

    computed: {
        showOptionSetting: function() {
            return this.$root.store.appData.enableSpeechTextOption || this.$root.store.appData.enableSpeechTextTrial;
        },

        sttEngineName: function () {
            return commonUtil.getSpeechToTextEngineName(this.$i18n, this.selectedSttEngineType);
        },

        translateEngineName: function () {
            return commonUtil.getTranslationEngineName(this.$i18n, this.selectedTranslationEngineType);
        },

        sttEngineCaution: function () {
            if (this.selectedSttEngineType === 2) {
                return commonUtil.getMessageText(this.$i18n,"info_stt_engine_cant_select_again");
            }
        }
    },

    created: function() {
        if (this.showOptionSetting) {
            this.getDictionaryInfo();
        }
        this.getP2PEngineInfo()
    },

    methods: {
        getDictionaryInfo: function() {
            let self = this;
            server.post('/getsttdictionaryinfo', {})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.dictionaryInfoList = res.data.dictionaryInfoList;
                            self.maxDictionaryCount = res.data.maxDictionaryCount;
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getDictionaryInfo").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self, "getDictionaryInfo", error);
                });
        },

        addDictionary() {
            if (this.dictionaryInfoList.length >= this.maxDictionaryCount) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_stt_extension_dictionary_exceeds_max_count").replace("{maxDictionaryCount}",this.maxDictionaryCount));
                return;
            }
            this.showDialogAfterWritableCheck("add");
        },

        assignDictionary(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.showDialogAfterWritableCheck("assign");
        },

        editDictionary(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.showDialogAfterWritableCheck("edit");
        },

        deleteDictionary(dictionary) {
            this.selectedDictionaryInfo = dictionary;
            this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "title_stt_extension_dictionary");
            this.confirmInfo.objectName = this.selectedDictionaryInfo.name;
            this.showDialogAfterWritableCheck("delete");
        },

        doAddDictionary(dictionaryName) {
            let self = this;
            server.post('/createsttdictionary', {dictionaryName: dictionaryName})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getDictionaryInfo();
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_stt_extension_dictionary_added"));
                            break;
                        case constants.STATUS_ERROR_INVALID_PARAMETER:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_name_already_exist"));
                            break;
                        case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_exceeds_max_count").replace("{maxDictionaryCount}",res.data.maxDictionaryCount));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doAddDictionary").replace("{code}",res.data.status));
                            break;
                    }
                    self.showDictionaryDialog.add = false;
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "doAddDictionary", error);
                    self.showDictionaryDialog.add = false;
                });
        },

        doAssignDictionary(input) {
            let operations = [];

            for (let key in input.addTagList) {
                let tag = input.addTagList[key];
                operations.push({
                    operation: 1, // add operation
                    talkGroupId: tag.talkgroupId,
                });
            }

            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key];
                operations.push({
                    operation: -1, // remove operation
                    talkGroupId: tag.talkgroupId,
                });
            }

            if (operations.length === 0) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                this.showDictionaryDialog.assign = false;
                return;
            }

            let self = this;
            server.post('/modifysttdictionaryassignment', {dictionaryId: this.selectedDictionaryInfo.id, operationDataList: operations})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            commonUtil.notifyMessage(self, 'Success', commonUtil.getMessageText(self.$i18n, "info_assign_stt_extension_dictionary"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doAssignDictionary").replace("{code}",res.data.status));
                            break;
                    }
                    self.showDictionaryDialog.assign = false;
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self,"doAssignDictionary",error);
                    self.showDictionaryDialog.assign = false;
                });
        },

        doEditDictionary(dictParams, phraseParams) {
            let dictChanged = dictParams.name !== this.selectedDictionaryInfo.name;
            let phraseChanged = phraseParams.inputList.length !== 0;

            if (!dictChanged && !phraseChanged) {
                commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
                this.showDictionaryDialog.edit = false;
                return;
            }

            let self = this;

            let discountShowDialogEdit = function() {
                let count = dictChanged + phraseChanged;
                return () => self.showDictionaryDialog.edit = (--count > 0);
            }();

            // modify dictionary name
            if (dictChanged) {
                server.post('/renamesttdictionary', dictParams)
                    .then((res) => {
                        switch (res.data.status) {
                            case constants.STATUS_SUCCESS:
                                self.getDictionaryInfo();
                                commonUtil.notifyMessage(self,'Success',commonUtil.getMessageText(self.$i18n, "info_modified_stt_extension_dictionary_name"));
                                break;
                            case constants.STATUS_ERROR_INVALID_PARAMETER:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                                break;
                            case constants.STATUS_ERROR_ALREADY_EXISTED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_name_already_exist"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doEditDictionary").replace("{code}",res.data.status));
                                break;
                        }
                        discountShowDialogEdit();
                    })
                    .catch(function(error) {
                        commonUtil.putExceptionErrorMessage(self,"doEditDictionary",error);
                        discountShowDialogEdit();
                    });
            }

            // modify phrases
            if (phraseChanged) {
                server.post('/modifysttdictionaryphrase', phraseParams)
                    .then((res) => {
                        switch(res.data.status) {
                            case constants.STATUS_SUCCESS:
                                commonUtil.notifyMessage(self,'Success',commonUtil.getMessageText(self.$i18n,"info_modified_stt_extension_dictionary_phrase"));
                                break;
                            case constants.STATUS_ERROR_INVALID_PARAMETER:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_invalid_params"));
                                break;
                            case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                                break;
                            case constants.STATUS_ERROR_ALREADY_EXISTED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                                break;
                            case constants.STATUS_ERROR_EXCEEDS_MAX_COUNT:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_phrase_exceeds_max_count").replace("{maxPhraseCountPerLang}",res.data.maxPhraseCountPerLang));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","doEditDictionary").replace("{code}",res.data.status));
                                break;
                        }
                        discountShowDialogEdit();
                    })
                    .catch(function(error) {
                        commonUtil.putExceptionErrorMessage(self,"doEditDictionary",error);
                        discountShowDialogEdit();
                    });
            }
        },

        doDeleteDictionary() {
            let self = this;
            server.post('/deletesttdictionary', {dictionaryId: this.selectedDictionaryInfo.id})
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.getDictionaryInfo();
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_deleted_stt_extension_dictionary"));
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                            break;
                        case constants.STATUS_ERROR_STILL_ASSIGNED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_cannot_delete_still_asigined_dictionary"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName","doDeleteDictionary").replace("{code}",res.data.status));
                            break;
                    }
                    self.showDictionaryDialog.delete = false;
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self,"doDeleteDictionary",error);
                    self.showDictionaryDialog.delete = false;
                });
        },

        showDialogAfterWritableCheck(command) {
            if (!this.$root.store.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }
            this.showDictionaryDialog[command] = true;
        },

        validateDictNameDuplicated(name, callback){
            for (let dict of this.dictionaryInfoList) {
                if (dict.name === name) {
                    callback(false, commonUtil.getMessageText(this.$i18n,"error_stt_extension_dictionary_name_already_exist"))
                    return
                }
            }
            callback(true, null)
        },

        showSettingP2PEngine(){
            if (!this.$root.store.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }

            this.showP2PEngineSettingDialog = true;
        },

        async setP2PEngine(sttEngineType, translationEngineType) {
            try {
                const res = await server.post('/updatep2pengine', { sttType: sttEngineType, translateType: translationEngineType })

                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (sttEngineType != null) {
                            this.selectedSttEngineType = sttEngineType;
                        }
                        if (translationEngineType != null) {
                            this.selectedTranslationEngineType = translationEngineType;
                        }
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_change_p2p_engine"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "setP2PEngine").replace("{code}", res.data.status));
                        break;
                }
            } catch(error) {
                commonUtil.putExceptionErrorMessage(self, "getCurrentP2PEngine", error);
            }
            this.showP2PEngineSettingDialog = false;
        },

        async getP2PEngineInfo() {
            try {
                const res = await server.post('/getcurrentp2pengine', {})

                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let p2pEngineInfo = res.data.P2PEngineInfo;
                        this.selectedSttEngineType = p2pEngineInfo["stt"];
                        this.selectedTranslationEngineType = p2pEngineInfo["translate"];
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getCurrentP2PEngine").replace("{code}", res.data.status));
                        break;
                }
            } catch(error) {
                commonUtil.putExceptionErrorMessage(this, "getCurrentP2PEngine", error);
            }
        },
    }
}


</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.icon-help {
    height: 14px;
}
.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}
.title-box-left {
    padding: 10px 10px 10px 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.object-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 12px;
}
.object-item2 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 28px;
    font-size: 12px;
    width: 10%;
    text-align: right;
}
.dict-title {
    background-color: #f6f6f6;
    color: #848991;
}
.dict-record {
    background-color:transparent;
    border-bottom: solid 1px #eee;
}
button.transparent img {
    display: inline;
    vertical-align: middle;
    height: 18px;
}

</style>
